export default __webpack_public_path__ + "static/media/delosi-bl.dd3785a1.png";